export default "__VITE_ASSET__c57a6d3b__"